/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * Routes Messages
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
  titleConstruct: {
    id: 'Routes_TitleConstruct',
    defaultMessage: '{title}'
  }
});